/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `planned` - Planned
 * * `executed` - Executed
 * * `canceled` - Canceled
 */
export enum EventStatusEnum {
    PLANNED = 'planned',
    EXECUTED = 'executed',
    CANCELED = 'canceled',
}
